import React, {useEffect, useRef} from 'react'
import Stack from '@mui/material/Stack';

import Item from './Item.js';
import { Grid, useMediaQuery, useTheme } from '@mui/material';

const SelectReason = ({onSelect, selected, array, match}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
        // Séparer le tableau en 2 colonnes équilibrées
    const mid = Math.ceil(array.length / 2);
    const column1 = array.slice(0, mid);
    const column2 = array.slice(mid);

    return (
        <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="flex-start"
        className='medium-padding'
        >
        {isMobile ? (
            // 1 colonne sur mobile
            array.map((r) => (
            <Grid item xs={12} key={r.id}>
                <Item
                selected={selected}
                onSelect={onSelect}
                value={r.value}
                id={r.id}
                disabled={r.disabled && r.disabled(match)}
                />
            </Grid>
            ))
        ) : (
            // 2 colonnes avec moitié de la liste dans chaque
            <>
            <Grid item xs={6}>
                {column1.map((r) => (
                <Item
                    key={r.id}
                    selected={selected}
                    onSelect={onSelect}
                    value={r.value}
                    id={r.id}
                    disabled={r.disabled && r.disabled(match)}
                />
                ))}
            </Grid>
            <Grid item xs={6}>
                {column2.map((r) => (
                <Item
                    key={r.id}
                    selected={selected}
                    onSelect={onSelect}
                    value={r.value}
                    id={r.id}
                    disabled={r.disabled && r.disabled(match)}
                />
                ))}
            </Grid>
            </>
        )}
        </Grid>
    );
    };

export default SelectReason